import util from '../util';
import { DEALER_DATA_REVISIONS } from './actionTypes';

export default util.requestReducer(DEALER_DATA_REVISIONS);
